export * from './storage-job-details-template';
